export enum Language {
	EN = 'en',
	ES = 'es',
	FR = 'fr'
}


// WEBPACK FOOTER //
// ./js/PFF/angular-modules/common/interfaces/Language.ts